import { useCallback, useMemo } from 'react';
import { useReduxForm } from '@rainbow-modules/hooks';
import { CheckboxGroupProps } from 'react-rainbow-components/components/CheckboxGroup';
import { Label, StyledCheckBoxGroup } from './styled';

interface Params extends Omit<CheckboxGroupProps, 'value' | 'onChange'> {
    events?: Array<{ name: string; description: string }>;
    value?: string[] | null;
    onChange?: (values: string[] | null) => void;
}

const WebhookEventsFilter = (props: Params) => {
    const {
        events = [],
        value: valueInProps,
        onChange = () => {},
        ...rest
    } = useReduxForm(props);

    const options = useMemo(
        () => events.map(
            (event) => ({
                value: event.name,
                label: <Label>{event.name}</Label>,
            }),
        ),
        [events],
    );

    const value = valueInProps ?? [];

    const handleOnChange = useCallback(
        (values: string[]) => {
            if (values.length === events.length) return onChange(null);
            return onChange(values);
        },
        [events.length, onChange],
    );

    return (
        <StyledCheckBoxGroup
            {...rest}
            hideLabel
            options={options}
            value={value}
            onChange={handleOnChange}
        />
    );
};

export default WebhookEventsFilter;
